import CircularProgress from '@mui/material/CircularProgress'

import { elfGreen } from 'Utils/styles/colors'

export const SimpleCircularProgress = () => (
  <CircularProgress style={{ color: elfGreen }} size={20} />
)
